import { Link as RouterLink } from 'react-router-dom'
import { Button, StatusWidget } from '@revolut-internal/ui-kit'
import { FC } from 'react'

import { getRootRoute } from 'lib/router'

interface NotFoundWidgetProps {
  title?: string
  description?: string
}

export const NotFoundWidget: FC<NotFoundWidgetProps> = ({
  title = 'Something went wrong',
  description,
}) => (
  <StatusWidget>
    <StatusWidget.Image
      image={{
        default: 'https://assets.revolut.com/assets/3d-images-v2/3D086.png',
        '2x': 'https://assets.revolut.com/assets/3d-images-v2/3D086@2x.png',
        '3x': 'https://assets.revolut.com/assets/3d-images-v2/3D086@3x.png',
      }}
    />
    <StatusWidget.Title>{title}</StatusWidget.Title>
    {description && <StatusWidget.Description>{description}</StatusWidget.Description>}
    <StatusWidget.Actions>
      <Button elevated use={RouterLink} to={getRootRoute()}>
        Home page
      </Button>
    </StatusWidget.Actions>
  </StatusWidget>
)
